import { getReminderTextFromValue } from 'shared/utils/events';

import { t } from '@/services/translations/config';

import {
    CONTACTS_REMINDER_STANDARD_ITEMS,
    USER_REMINDER_STANDARD_ITEMS,
} from '../constants';

import {
    CustomOptionItem,
    CustomOptionItemType,
} from './SelectWithCustomInput/components/CustomOptionsInputModal/types';

const getOptionFromReminderValue = (value: string): CustomOptionItem => {
    return {
        value,
        text: getReminderTextFromValue(value, t),
        type: CustomOptionItemType.Standard,
    };
};

const createQuickReminderOptions = ({
    currentValue,
    reminderPickerItems,
    currentOptionPosition = 0,
}: {
    currentValue?: string | null;
    reminderPickerItems: Pick<CustomOptionItem, 'value' | 'type'>[];
    currentOptionPosition?: number;
}): CustomOptionItem[] => {
    const quickOptions: CustomOptionItem[] = reminderPickerItems.map(
        (item) => ({
            ...item,
            text: getReminderTextFromValue(item.value, t),
        }),
    );

    if (!currentValue) {
        return quickOptions;
    }

    const currentOption = getOptionFromReminderValue(currentValue);

    if (
        !reminderPickerItems.find((item) => item.value === currentOption.value)
    ) {
        quickOptions.splice(currentOptionPosition, 0, currentOption);
    }

    return quickOptions;
};

const createUserReminderOptions = (
    currentValue?: string | null,
): CustomOptionItem[] => {
    return createQuickReminderOptions({
        currentValue,
        reminderPickerItems: USER_REMINDER_STANDARD_ITEMS,
        currentOptionPosition: 1,
    });
};

const createContactsReminderOptions = (
    currentValue?: string | null,
): CustomOptionItem[] => {
    return createQuickReminderOptions({
        currentValue,
        reminderPickerItems: CONTACTS_REMINDER_STANDARD_ITEMS,
    });
};

export {
    getOptionFromReminderValue,
    createQuickReminderOptions,
    createUserReminderOptions,
    createContactsReminderOptions,
};
